import { useQuery } from '@tanstack/react-query';
import { getSettings } from '../services/platform/settingsService';

const SETTING_CATEGORY = 'partner_onboarding';
const SETTING_KEY = 'mask_email_and_phone';

/**
 * When true (default), partner/user lists mask email and phone.
 * Toggle in Settings → Partner Onboarding.
 */
export function useMaskContactSetting() {
  const { data: settings, isLoading } = useQuery({
    queryKey: ['settings', SETTING_CATEGORY],
    queryFn: () => getSettings(SETTING_CATEGORY),
    staleTime: 60_000,
  });

  const row = settings?.find((s) => s.key === SETTING_KEY);
  const maskEnabled = row ? row.value === 'true' : true;

  return { maskEnabled, isLoading };
}
